"use client";

import { c as _c } from "react/compiler-runtime";
import { useUserbackFeedback } from "@/hooks/use-userback-feedback";
import { Lightbulb } from "lucide-react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";
export function SuggestFeatureCard(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  const {
    openFeedback
  } = useUserbackFeedback();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Lightbulb className="w-full h-full" strokeWidth={1.5} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== openFeedback) {
    t2 = <PromotionalCardBase icon={t1} title="Have an Idea?" description={"Help us build a better home-buying experience \u2014 your feedback shapes our roadmap"} ctaText="Suggest a Feature" onClick={openFeedback} className={className} iconColor="text-amber-500" />;
    $[1] = className;
    $[2] = openFeedback;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}